import type { Organization } from '../../types'
import type { Order } from './types'
import { unparse } from 'papaparse'

export function downloadCSV(data: Organization[]) {
  const headers = Object.keys(data[0]).filter(
    (key) =>
      ![
        'id',
        'initCommTask',
        'lat',
        'long',
        'Latitude',
        'Longitude',
        'Full Address',
        'fullAddress',
      ].includes(key)
  )

  const formattedData = data.map((row) => {
    return headers.reduce((acc, header) => {
      if (header === 'initiative_commission_taskforce') {
        const val = row[header]
        // @ts-ignore
        acc[header] = val ? 'TRUE' : 'FALSE'
      } else {
        // @ts-ignore
        acc[header] = row[header]
      }
      return acc
    }, {})
  })

  let csvContent = 'data:text/csv;charset=utf-8,' + unparse(formattedData)
  const encodedUri = encodeURI(csvContent)
  const link = document.createElement('a')
  link.setAttribute('href', encodedUri)
  link.setAttribute('download', 'data.csv')
  document.body.appendChild(link)
  link.click()
}

export function descendingComparator<T>(a: T, b: T, orderBy: keyof T) {
  // @ts-ignore
  if (a[orderBy] === undefined || b[orderBy] < a[orderBy]) {
    return -1
  }
  // @ts-ignore
  if (b[orderBy] === undefined || b[orderBy] > a[orderBy]) {
    return 1
  }
  return 0
}

export function getComparator<Key extends keyof any>(
  order: Order,
  orderBy: Key
): (
  a: { [key in Key]: number | string | string[] },
  b: { [key in Key]: number | string | string[] }
) => number {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy)
}

export function stableSort<T>(
  array: readonly T[],
  comparator: (a: T, b: T) => number
) {
  const stabilizedThis = array.map((el, index) => [el, index] as [T, number])
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0])
    if (order !== 0) {
      return order
    }
    return a[1] - b[1]
  })
  return stabilizedThis.map((el) => el[0])
}
